// SIMNOPSIS sample datasets — demo audios generated via Gemini TTS
// Full masters + playable highlight cuts under /samples and /samples/clips

export const THEME_MAP = {
  cyan:   { color: '#20B8F2', name: 'HARD TRUTHS' },
  mint:   { color: '#7EE06D', name: 'ADVICE' },
  violet: { color: '#A78BFA', name: 'TURNING POINTS' },
  amber:  { color: '#F2B84C', name: 'INSIGHTS' },
  coral:  { color: '#F2704C', name: 'MOMENTS' },
};

export const SAMPLES = [
  {
    id: 'podcast-founder-42',
    category: 'PODCAST',
    categoryColor: '#20B8F2',
    source: 'Founder Signal · Ep. 42',
    duration: '02:56',
    durationSec: 176,
    scanned: 187,
    themesFound: 5,
    photo: '/usecases/podcast.png',
    audioSrc: '/samples/podcast-founder-42.mp3',
    tags: ['HARD TRUTHS', 'TURNING POINTS', 'ADVICE'],
    tagline: 'Founder podcast: facing the runway truth',
    description: 'A sample founder interview — SIMNOPSIS surfaces the hard admission, the midnight breakthrough, and the advice worth keeping.',
    highlights: [
      {
        id: 'h1',
        theme: 'cyan',
        themeName: 'HARD TRUTHS',
        title: 'The Runway Confession',
        quote: "We had runway, a team that trusted us, and a product nobody wanted. I had to say it plainly: if we keep going like this, we will not make it.",
        rating: 9.4,
        start: '00:48',
        startSec: 48,
        durationSec: 12,
        length: '0:12',
        excerpt: 'The founder names the failure before the room can soften it.',
        clipSrc: '/samples/clips/h1.mp3',
      },
      {
        id: 'h2',
        theme: 'violet',
        themeName: 'TURNING POINTS',
        title: 'Honesty Changes the Room',
        quote: "That is a high point because it is honest — and a turning point because everything after it changes. The console shows upload, transcription, detection, slicing, and titles.",
        rating: 9.2,
        start: '01:22',
        startSec: 82,
        durationSec: 14,
        length: '0:14',
        excerpt: 'The honest admission becomes the pivot that moves the conversation forward.',
        clipSrc: '/samples/clips/h2.mp3',
      },
      {
        id: 'h3',
        theme: 'mint',
        themeName: 'ADVICE',
        title: 'Love the Problem First',
        quote: "Fall in love with the problem. Your solution will change ten times. The problem is what people actually care about — stay close to that and you survive the pivots.",
        rating: 8.9,
        start: '02:10',
        startSec: 130,
        durationSec: 12,
        length: '0:12',
        excerpt: 'A distilled lesson for anyone building under pressure.',
        clipSrc: '/samples/clips/h3.mp3',
      }
    ]
  },
  {
    id: 'lecture-mit-econ',
    category: 'RESEARCH',
    categoryColor: '#F2704C',
    source: 'Cognitive Markets · Session 07',
    duration: '02:41',
    durationSec: 161,
    scanned: 214,
    themesFound: 5,
    photo: '/usecases/research.png',
    audioSrc: '/samples/lecture-mit-econ.mp3',
    tags: ['INSIGHTS', 'TURNING POINTS', 'ADVICE'],
    tagline: 'Research lecture: why loss hurts more than gain',
    description: 'A sample behavioral research talk on loss aversion — the experiments, market surprises, and pricing insight that change how value feels.',
    highlights: [
      {
        id: 'l1',
        theme: 'amber',
        themeName: 'INSIGHTS',
        title: 'Loss Stings Twice as Hard',
        quote: "Losing a hundred dollars stings about twice as much as gaining a hundred feels good. That asymmetry explains more market behavior than rational models ever will.",
        rating: 9.6,
        start: '00:52',
        startSec: 52,
        durationSec: 12,
        length: '0:12',
        excerpt: 'The core finding behind loss aversion, made concrete.',
        clipSrc: '/samples/clips/l1.mp3',
      },
      {
        id: 'l2',
        theme: 'violet',
        themeName: 'TURNING POINTS',
        title: 'Ownership Rewrites Value',
        quote: "The moment you own the mug, its value in your head jumps. Ownership rewires what something is worth. The endowment effect holds everywhere we looked.",
        rating: 9.1,
        start: '01:18',
        startSec: 78,
        durationSec: 12,
        length: '0:12',
        excerpt: 'A classic experiment reframed as a universal valuation shift.',
        clipSrc: '/samples/clips/l2.mp3',
      },
      {
        id: 'l3',
        theme: 'mint',
        themeName: 'ADVICE',
        title: 'Sell the Fear of Losing',
        quote: "Frame subscriptions around what people lose by leaving, not what they gain by paying. Price the fear of losing, not the joy of gaining.",
        rating: 8.7,
        start: '01:48',
        startSec: 108,
        durationSec: 12,
        length: '0:12',
        excerpt: 'A practical takeaway from research, not theory alone.',
        clipSrc: '/samples/clips/l3.mp3',
      }
    ]
  },
  {
    id: 'discourse-night-circle',
    category: 'DISCOURSES',
    categoryColor: '#A78BFA',
    source: 'Evening Circle · Reflection 03',
    duration: '02:46',
    durationSec: 166,
    scanned: 142,
    themesFound: 4,
    photo: '/usecases/discourses.png',
    audioSrc: '/samples/discourse-night-circle.mp3',
    tags: ['HARD TRUTHS', 'MOMENTS', 'ADVICE'],
    tagline: 'Evening discourse: counsel that stays with you',
    description: 'A sample reflective discourse on sincerity, patience, and the truths that surface in gathering, silence, and remembrance.',
    highlights: [
      {
        id: 'd1',
        theme: 'cyan',
        themeName: 'HARD TRUTHS',
        title: 'Heart Before the Tongue',
        quote: "The heart often knows before the tongue admits. We dress our intentions in beautiful language, but the heart knows when action has not caught up. That gap is where most spiritual harm begins.",
        rating: 9.3,
        start: '00:55',
        startSec: 55,
        durationSec: 15,
        length: '0:15',
        excerpt: 'A quiet admission about the distance between word and deed.',
        clipSrc: '/samples/clips/d1.mp3',
      },
      {
        id: 'd2',
        theme: 'coral',
        themeName: 'MOMENTS',
        title: 'The Room Fell Silent',
        quote: "Someone asked not what we believe, but what we are willing to give up for it. The silence after that question was the most honest part of the night.",
        rating: 8.8,
        start: '01:28',
        startSec: 88,
        durationSec: 12,
        length: '0:12',
        excerpt: 'A turning moment when reflection replaces performance.',
        clipSrc: '/samples/clips/d2.mp3',
      },
      {
        id: 'd3',
        theme: 'mint',
        themeName: 'ADVICE',
        title: 'Keep What Lifts You',
        quote: "Do not carry every opinion home with you. Take what lifts you; leave what burdens you. Keep the counsel that makes you softer, more truthful, and more useful to others.",
        rating: 8.5,
        start: '02:05',
        startSec: 125,
        durationSec: 14,
        length: '0:14',
        excerpt: 'Closing counsel on discernment after a long evening of speech.',
        clipSrc: '/samples/clips/d3.mp3',
      }
    ]
  }
];

export function getSample(id) {
  return SAMPLES.find(s => s.id === id);
}

export function themeColor(key) {
  return THEME_MAP[key]?.color || '#20B8F2';
}

/** Resolve theme hex from a display name like "HARD TRUTHS" or a key like "cyan". */
export function themeColorByName(nameOrKey) {
  const raw = String(nameOrKey || '').trim();
  if (!raw) return '#20B8F2';
  if (THEME_MAP[raw]) return THEME_MAP[raw].color;
  const upper = raw.toUpperCase();
  const hit = Object.values(THEME_MAP).find((t) => t.name === upper || t.name === raw);
  return hit?.color || '#20B8F2';
}

/** Prefer static demo clip path, else HX clip id URL helper input. */
export function resolveHighlightAudioSrc(highlight) {
  if (!highlight) return null;
  if (highlight.clipSrc) return highlight.clipSrc;
  if (highlight.audioSrc) return highlight.audioSrc;
  return null;
}
